/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-autofocus */
import React, { useEffect, useRef } from "react"
import { connect } from "react-redux"
import { useOnClickOutside, usePrevious } from "app/static/frontend/imports/hooks"

import { listAdderConnection } from "shared/profiles/listAdder/selectors"
import { addListItem, removeListItem, getListsForResource } from "shared/profiles/listAdder/action-creators"

import { segueToProfileWithId } from "app/static/frontend/global-action-creators"

import { idFromResourceUri } from "shared/imports/sharedHelperFunctions"

import SelectedObjects from "components/SelectedObjects"
import { ListSelect } from "app/static/frontend/selects/containers/PieSelect"

import { SelectWithRemovableValues, WorkflowComponent, WorkflowStrip } from "quorumdesign"

export const NewListAdder = (props) => {
    const newListAdderRef = useRef()
    useOnClickOutside(newListAdderRef, (e) => {
        if (props.datumId && props.datumId.toString() !== e.target.id) {
            return props.handleClickOutside()
        }
        return null
    })
    const prevProps = usePrevious(props)

    useEffect(() => {
        if (!props.datumId || !props.model) {
            return
        }

        if (prevProps?.datumId !== props.datumId && props.datumId) {
            // make sure datumId is defined
            props.getListsForResource({
                id: props.datumId,
                dataType: props.model,
            })
        }
    }, [props, prevProps])

    const addToList = (list) =>
        props.addListItem({
            list,
            item: { id: props.datumId },
            dataType: props.model,
            region: props.region,
        })
    const removeFromList = (list) =>
        props.removeListItem({
            list,
            item: { id: props.datumId },
            dataType: props.model,
            region: props.region,
        })

    const renderLists = () => (
        <span>
            {props.projects && !!props.projects.length ? (
                <div className={`${props.inline ? "inline-div" : ""} list-adder-overflow`}>
                    {props.projects.map((project) => (
                        <div
                            key={project.id}
                            className="board-wrapper searchable-group multi-dropdown-menu for-new-list"
                        >
                            <a className="list-group-item list-group-title">{project.name}</a>
                            <SelectedObjects
                                tagObjects={project.lists}
                                onObjDelete={(obj) => removeFromList(obj.self)}
                                onClickObj={() => null}
                            />
                        </div>
                    ))}
                </div>
            ) : (
                <div className="board-wrapper searchable-group multi-dropdown-menu">
                    <ul className="quorum-selected-objects no-results">
                        <li className="quorum-tag loading blue-tag-1 no-results">
                            <h4>{props.noResultsType} not assigned to any lists</h4>
                        </li>
                    </ul>
                </div>
            )}
        </span>
    )
    const renderHeader = () => (
        <span>
            {props.inline ? (
                <div className="list-group stat-list-header">
                    <a className="list-group-item active stat-list-panel">
                        <span>{props.loading ? "Loading..." : "Lists"}</span>
                    </a>
                </div>
            ) : (
                <div className="list-adder-head">{props.loading ? "Loading..." : "Add to List"}</div>
            )}
        </span>
    )

    const renderListStrips = () =>
        props.projects &&
        !!props.projects.length &&
        props.projects.map((project) => (
            <React.Fragment key={project.id}>
                <WorkflowStrip
                    key={project.id}
                    icon="thumbtack"
                    iconColor="primary"
                    iconFamily="far"
                    text={project.name}
                    textType="major"
                />
                {Boolean(project.lists && project.lists.length) &&
                    project.lists.map((list) => (
                        <WorkflowStrip
                            key={list.id}
                            icon="list-ul"
                            iconColor="secondary"
                            iconFamily="far"
                            text={list.text}
                            textType="minor"
                            hoverActions={[
                                !list.locked && {
                                    text: "Remove",
                                    icon: "trash-alt",
                                    iconFamily: "fas",
                                    onClickFn: () => removeFromList(list.self),
                                },
                            ]}
                            onClickFn={() =>
                                props.segueToProfileWithId(
                                    // project id is of the form "/api/project/12345/"
                                    idFromResourceUri(project.id),
                                    DjangIO.app.models.QuorumDataType.issue_management.value,
                                    "lists/",
                                )
                            }
                        />
                    ))}
            </React.Fragment>
        ))

    return !props.inline ? (
        <WorkflowComponent
            emptyButton={
                !props.loading && {
                    text: "Add to List",
                    icon: "plus",
                    shouldOpenPopUp: true,
                }
            }
            emptyText={props.loading ? "Loading lists..." : "No lists currently"}
            iconTooltipText="Add"
            title="Add to List"
            popUpComponent={
                <ListSelect
                    autoFocus
                    defaultMenuIsOpen
                    isDesignSystem
                    isFocused
                    onChange={addToList}
                    permanentFilter={{
                        data_type: props.model,
                        dehydrate_extra: "project_name",
                        locked: false,
                    }}
                    requiresBaseComponent
                    value={0}
                />
            }
        >
            {!props.loading && renderListStrips()}
        </WorkflowComponent>
    ) : (
        <React.Fragment>
            {
                <SelectWithRemovableValues
                    clickOutsideRef={newListAdderRef}
                    dataCy="lists-search-table-column"
                    SelectComponent={
                        <ListSelect
                            autoFocus
                            defaultMenuIsOpen
                            isDesignSystem
                            isFocused
                            onChange={addToList}
                            permanentFilter={{
                                data_type: props.model,
                                dehydrate_extra: "project_name",
                                locked: false,
                            }}
                            requiresBaseComponent
                            value={0}
                        />
                    }
                    values={props.formattedValues}
                    valueStripOnClick={(project) =>
                        props.segueToProfileWithId(
                            // project id is of the form "/api/project/12345/"
                            idFromResourceUri(project.id),
                            DjangIO.app.models.QuorumDataType.issue_management.value,
                            "lists/",
                        )
                    }
                    valueStripRemove={(list) => removeFromList(list.self)}
                />
            }
        </React.Fragment>
    )
}

// also define InlineNewListAdder
export const InlineListAdder = connect((state, props) => listAdderConnection(state, props), {
    addListItem,
    removeListItem,
    getListsForResource,
})(NewListAdder)

export default connect((state, props) => listAdderConnection(state, props), {
    addListItem,
    removeListItem,
    getListsForResource,
    segueToProfileWithId,
})(NewListAdder)
